import { ConfigProvider, Modal, Table } from 'antd'
import React, { useState } from 'react'
import { getRowClassName } from '../../helpers/engineerConfirmation/listHelper'
import { monthList } from '../../utils/data';

function ChartModal({
    isModalOpen,
    handleOk,
    handleCancel,
    quarterModalData,
    id = '',
    year
}) {
    const doesEmployeeColumnExists = quarterModalData.some((item) => item.empName);
    const columns = [
        {
            title: "Principal",
            dataIndex: "principalName",
            key: "principalName",
            width: "20%",
        },
        {
            title: "Order Date",
            dataIndex: "orderDate",
            key: "orderDate",
            width: "27%",
            onHeaderCell: () => ({
                whitespace: 'nowrap'
            }),
            render: (orderDate) => {
                let date = new Date(orderDate);
                let monthDate = date.getDate();
                monthDate = monthDate < 10 ? `0${monthDate}` : monthDate;
                let month = date.getMonth() + 1;
                let monthName = monthList[month - 1].short;
                if (month < 10) {
                    month = `0${month}`;
                }
                let year = date.getFullYear();
                return `${monthDate}-${monthName}-${year}`;
            }
        },
        {
            title: "Ach. Price",
            dataIndex: "achValue",
            key: "achValue",
            width: "15%",
            sorter: (a, b) => a.achValue - b.achValue,
            onHeaderCell: () => ({
                whitespace: 'nowrap'
            }),
            render: (achValue) => {
                let formattedVal = achValue >= 10000000 ?
                    `${(achValue / 10000000).toFixed(2)} Cr` :
                    `${(achValue / 100000).toFixed(2)} Lac`;

                return formattedVal;
            }
        },
        {
            title: "Payment Received",
            dataIndex: "payment",
            key: "payment",
            width: "20%",
            sorter: (a, b) => a.payment - b.payment,
            render: (payment) => {
                let formattedVal = payment >= 10000000 ?
                    `${(payment / 10000000).toFixed(2)} Cr` :
                    `${(payment / 100000).toFixed(2)} Lac`;

                return formattedVal;
            }
        },
        {
            title: "Customer",
            dataIndex: "customer",
            key: "customer",
            onCell: () => ({
                style: { whiteSpace: 'nowrap' }, // Data cell styles
            }),
        }
    ];

    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    return (
        <Modal
            title={(id && !id.includes("yearly")) ? `Target - ${id.slice(-2).toUpperCase()}, FY: ${year - 1}-${year}` : 'Yearly Target'}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            style={{
                width: "100%",
                minWidth: '70%',
                overflow: "auto",
                maxWidth: "90%",
            }}
        >
            <ConfigProvider
                theme={{
                    components: {
                        Table: {
                            borderColor: "lightgrey",
                            headerBg: "#da251c",
                            headerColor: "white",
                            cellFontSizeSM: 6,
                            rowHoverBg: "#f2f2f2",
                            cellPaddingBlock: 8,
                            cellPaddingInlineSM: 2,
                            fontSize: '13px',
                            headerBorderRadius: "0px"
                        },
                    },
                }}
            >
                <Table
                    columns={doesEmployeeColumnExists ? [...columns, {
                        title: "Employee",
                        dataIndex: "empName",
                        key: "empName",
                        width: "20%",
                        onHeaderCell: () => ({
                            whitespace: 'nowrap'
                        }),
                    },] : columns}
                    scroll={{ x: 1500 }}
                    bordered
                    dataSource={quarterModalData}
                    pagination={tableParams.pagination}
                    onChange={handleTableChange}
                    style={{ overflowX: "auto" }}
                    rowClassName={getRowClassName}
                    rowKey={() => Math.floor(Math.random() * 123456)}
                />
            </ConfigProvider>
        </Modal>
    )
}

export default ChartModal